var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-primary scroll-smooth",style:(_vm.computedStyle),attrs:{"onclick":_vm.targetOnClick,"target":_vm.newTab ? '_blank' : undefined,"href":_vm.targetUrl,"rel":_vm.content.targetType === 'page' ? 'keep-params' : undefined},domProps:{"innerHTML":_vm._s(_vm.content.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }